import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { map, catchError } from 'rxjs/operators';
import { Utilisateur } from '@app/models/utilisateur';

@Injectable()
export class UtilisateurService {
    constructor(
        private httpClient: HttpClient
    ) { }

    // tous les utilisateurs
    getUtilisateurs() {
        return this.httpClient
            .get<any>(`${environment.apiEndPoint}utilisateurs`)
            .pipe(
                map(res => res ? res.document.records as Utilisateur[] : []),
                catchError(this.handleError)
            );
    }

    // tous les utilisateurs pour un role donné
    getUtilisateursById(roleId) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateurs/read`, JSON.stringify({ id: `${roleId}` }))
            .pipe(
                map(res => res ? res.document.records as Utilisateur[] : []),
                catchError(this.handleError)
            );
    }

    // Admin get users
    getUtilisateursExcludingMe(id) {
        return this.httpClient
        .post<any>(`${environment.apiEndPoint}utilisateurs/read_manage`, JSON.stringify({ id: `${id}` }))
        .pipe(
            map(res => res ? res.document.records as Utilisateur[] : []),
            catchError(this.handleError)
        );
    }

    // un utilisateur pour un id donné
    getUtilisateurById(id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateur/read_one`, JSON.stringify({ id: `${id}` }))
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // Detail admin d'un utilisateur avec historique des credits
    getUtilisateurDetails(id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateur/read_detail`, JSON.stringify({ id: `${id}` }))
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // Ajustement admin historise des credits utilisateur
    adjustUtilisateurCredits(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateur/credit_adjustment`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // creation utilisateur
    createUtilisateur(object: Utilisateur) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateur/create`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // mise a jour utilisateur
    updateUtilisateur(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateur/update`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // Admin mise a jour utilisateur
    updateUtilisateurExcludingMe(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}utilisateur/update_manage`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    deleteUtilisateur(object: Utilisateur) {
        return this.httpClient
            .post(`${environment.apiEndPoint}utilisateur/delete`, object)
            .pipe(
                map(() => null),
                catchError(this.handleError)
            );
    }

    // Admin
    deleteListUtilisateur(stringList: string) {
        return this.httpClient
            .post(`${environment.apiEndPoint}utilisateur/delete_manage`, JSON.stringify({ listId: `${stringList}` }))
            .pipe(
                map(() => null),
                catchError(this.handleError)
            );
    }

    private handleError(error: any): Promise<any> {
        let retour = error?.error?.message || error?.message || error;
        if(error?.error?.data) retour += '<br />'+error?.error?.data;
        return Promise.reject(retour);
    }
}
